<div class="card-header">
  @if (title) {
    <div class="card-title">
      <h4>{{title}}</h4>
    </div>
  }
  @if (showTotal && items?.length) {
    <p class="text-muted m-0">Total: {{ totalItems }}</p>
  }
  @if (showContextMenu || selectable) {
    <app-action-dropdown [actions]="actions" [actionClass]="actionClass"
      [actionItem]="selectedItems" [showBadge]="selectActive && selectedItems.length > 0"
      [badgeCount]="selectedItems.length">
    </app-action-dropdown>
  }
</div>
<div class="card-body card-list pt-0">
  @if (items && items?.length && !isLoading) {
    <div class="row">
      <div [class]="'d-table w-100 ' + tableSizeClass">
        <table [class]="'animated-table table' + (class ? ' ' + class : '')">
          @if (showTitles()) {
            <thead>
              <tr>
                @for (columnTitle of columnTitles; track columnTitle; let index = $index) {
                  @if (!!columnTitle && !!cellProps[index].sortProperty) {
                    <th
                      [sortable-column]="cellProps[index].sortProperty" [data-type]="cellProps[index].sortDataType"
                    [class]="cellProps[index].class ? cellProps[index].class : ''">{{ columnTitle | translate }}</th>
                  }
                  @if (!(!!columnTitle && !!cellProps[index].sortProperty)) {
                    <th
                    [class]="cellProps[index].class ? cellProps[index].class : ''">{{ columnTitle | translate }}</th>
                  }
                }
                @if (selectActive) {
                  <th class="select"></th>
                }
              </tr>
            </thead>
          }
          <tbody>
            @for (item of getDisplayItems(); track item; let index = $index) {
              <tr class="w-100">
                @for (cell of cellProps; track cell; let index = $index) {
                  @if (!cell.hidden) {
                    @switch (typeResolver(cell, item)) {
                      @case (cellTypes.image) {
                        <td>
                          <img [src]="resolveData(cell, item)" />
                        </td>
                      }
                      @case (cellTypes.link) {
                        <td
                          [class]="classResolver(cell, item) + ' cell-link-block' + (iconResolver(cell, item) ? ' text-nowrap':'')">
                          <a href="#" (click)="clickHandler($event, item, index)">
                            @if (iconResolver(cell, item)) {
                              <i [class]="'now-ui-icons ' + iconResolver(cell, item)"></i>
                            }
                            {{ cell.text ? (cell.text | translate): resolveData(cell, item) }}
                          </a>
                        </td>
                      }
                      @case (cellTypes.icon) {
                        <td
                          [class]="classResolver(cell, item) + (iconResolver(cell, item) ? ' text-nowrap':'')">
                          <span>
                            @if (iconResolver(cell, item)) {
                              <i [class]="'now-ui-icons ' + iconResolver(cell, item)"
                              ></i>
                            }
                          </span>
                        </td>
                      }
                      @default {
                        <td [innerHtml]="cell.text ? (cell.text | translate): resolveData(cell, item)"
                        [class]="classResolver(cell, item)"></td>
                      }
                    }
                  }
                }
                @if (selectable) {
                  <td class="text-muted text-right select">
                    @if (isRowSelectActive(item)) {
                      <a [ngClass]="{'selected': rowSelected(item)}"
                        (click)="toggleSelection(item)">
                        @if (rowSelected(item)) {
                          <span class="material-icons">check_box</span>
                        }
                        @if (!rowSelected(item)) {
                          <span class="material-icons">check_box_outline_blank</span>
                        }
                      </a>
                    }
                  </td>
                }
              </tr>
            }
          </tbody>
          @if (hasFooter()) {
            <tfoot>
              <tr>
                @for (cell of cellProps; track cell; let index = $index) {
                  @if (!cell.footerResolver) {
                    <td></td>
                  }
                  @if (cell.footerResolver) {
                    <td [class]="classResolver(cell, item)">
                      {{ footerResolver(cell, items, selectedItems) }}
                    </td>
                  }
                }
              </tr>
            </tfoot>
          }
        </table>
        @if (pagination && totalItems > pageSize) {
          <ngb-pagination class="mt-3" (pageChange)="paginationChanged($event)"
            [collectionSize]="totalItems" [(page)]="page" [maxSize]="paginationMaxSize" [pageSize]="pageSize"
            style="display: table-footer-group">
          </ngb-pagination>
        }
      </div>
    </div>
  }
  @if (items && !items.length && !isLoading && noResult) {
    <div class="row">
      <p class="no-records">{{ noResult | translate }}</p>
    </div>
  }

  @if (!items || isLoading) {
    <div>
      <span class="loading"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
    </div>
  }
  <ng-content></ng-content>
</div>